const rLt = /</g;
const rGt = />/g;
const rLte = /&lt;/g;
const rGte = /&gt;/g;
const rEnc = /[<>]/;
const rDec = /&lt;|&gt;/;

const coerceToString = (val) => (val ? String(val) : '');

/** HTML Template Friendly Encoding and Stringification of State Objects */
export function dehydrate<T>(obj: T): string {
  const str = JSON.stringify(obj);
  const val = coerceToString(str);
  if (rEnc.test(val)) {
    return val.replace(rLt, '&lt;').replace(rGt, '&gt;');
  }
  return val;
}

export function hydrate<T>(str: string | undefined): T {
  if (!str) return {} as T;
  const val = coerceToString(str);
  if (rDec.test(val)) {
    return JSON.parse(val.replace(rLte, '<').replace(rGte, '>')) as T;
  }
  return JSON.parse(val) as T;
}
